import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.InicioCargaDescarga;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un InicioCargaDescarga
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdCajaRuta: validation.required,
        IdChofer: validation.required,
        Tipo: validation.required
    };
    return validation.getErrors(rules, x);
}

const IniciarButton = kea.defaultProps(kea.Button, { children: "Iniciar proceso" , style: "info", iconClass: fa("arrow-right")  });

/**
* Modal de edición para un InicioCargaDescarga
*/
export class InicioCargaDescargaEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const CajaRuta = getField(selectores.CajaRuta);
        const TipoCargaDescarga = getField(selectores.TipoCargaDescarga);
        const Chofer = getField(selectores.ChoferRuta);

        return (
            <kea.Modal
                buttons={[<IniciarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Iniciar carga/descarga"
            >

                {kea.autogrid(4, [
                    <TipoCargaDescarga field="Tipo" />,
                    <CajaRuta field="IdCajaRuta" label="Caja" />,
                    <Chofer field="IdChofer" label="Chofer" />
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cajas/nuevacarga.tsx